(function () {
  if (window.stud100CartUpsellLoaded) return;
  window.stud100CartUpsellLoaded = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-upsell-add]');
    if (!button || button.classList.contains('is-loading')) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    var body = new URLSearchParams();
    body.append('id', variantId);
    body.append('quantity', '1');

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: body.toString(),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status === 422) {
            throw new Error(data.description || 'Unable to add this product to the cart.');
          }
          return data;
        });
      })
      .then(function (product) {
        // Use Impulse's existing AJAX cart flow. CartDrawer listens for this
        // event and rebuilds cart.ajax.liquid, so items, totals, count and
        // recommendations all refresh without a page reload.
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: button
          }
        }));
      })
      .catch(function (error) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        window.alert(error.message);
      });
  });
})();
